import component from "./src/components"; // 云枢原生组件
import { register } from "./utils/register";
import extendComponent from "@cloudpivot/form/components-extend";
const components = [...component, ...extendComponent];
export default function () {
    for (let cmp of components) {
        register.append(cmp);
    }
}
